
/**
 * 강의 콘텐츠 지원 플랫폼 환경
 */
export type CourseDraftDetailResponseSectionsItemLecturesItemPlatformSupport = typeof CourseDraftDetailResponseSectionsItemLecturesItemPlatformSupport[keyof typeof CourseDraftDetailResponseSectionsItemLecturesItemPlatformSupport];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CourseDraftDetailResponseSectionsItemLecturesItemPlatformSupport = {
  IDE_ONLY: 'IDE_ONLY',
  WEB_ONLY: 'WEB_ONLY',
  IDE_AND_WEB: 'IDE_AND_WEB',
} as const;
